"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _classnames = _interopRequireDefault(require("classnames"));
var _merge2 = _interopRequireDefault(require("lodash/merge"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdStyleBible = _interopRequireDefault(require("cccisd-style-bible"));
var _cccisdTabs = _interopRequireDefault(require("cccisd-tabs"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdLaravelAssignment = require("cccisd-laravel-assignment");
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil5"));
var _copy = _interopRequireDefault(require("cccisd-icons/copy"));
var _list = _interopRequireDefault(require("cccisd-icons/list2"));
var _envelop = _interopRequireDefault(require("cccisd-icons/envelop5"));
var _UrlInfo = require("../../../pages/DeployTrack/UrlInfo");
var _helpers = require("../../ModalContents/helpers");
var _LoggedPawnMessages = _interopRequireDefault(require("./LoggedPawnMessages"));
var _SendMessageNow = _interopRequireDefault(require("./SendMessageNow"));
var _SurveySelector = _interopRequireDefault(require("./SurveySelector"));
var _assignment = _interopRequireDefault(require("./assignment.graphql"));
var _table = _interopRequireDefault(require("./table.graphql"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Boilerplate = window.cccisd.boilerplate;
var AppDefs = window.cccisd && window.cccisd.appDefs;
var flowDefaultValues = AppDefs.flow.defaultValueVariables;
function OutcomesData(_ref) {
  var _ref$questprojectIds = _ref.questprojectIds,
    questprojectIds = _ref$questprojectIds === void 0 ? [] : _ref$questprojectIds,
    groups = _ref.groups,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Outcomes Data' : _ref$title,
    tableQuery = _ref.tableQuery,
    messageQuery = _ref.messageQuery,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? '' : _ref$description,
    _ref$tableFields = _ref.tableFields,
    tableFields = _ref$tableFields === void 0 ? [] : _ref$tableFields,
    _ref$tableColumns = _ref.tableColumns,
    tableColumns = _ref$tableColumns === void 0 ? [{
      name: 'pawn.pawnId',
      label: 'System ID',
      sort: true,
      filter: true
    }, {
      name: 'user.firstName',
      label: 'First Name',
      sort: true,
      filter: true
    }, {
      name: 'user.lastName',
      label: 'Last Name',
      sort: true,
      filter: true
    }, {
      name: 'user.username',
      label: 'Username',
      sort: true,
      filter: true
    }] : _ref$tableColumns,
    modalTitleField = _ref.modalTitleField,
    formatDefaultValues = _ref.formatDefaultValues;
  var _useParams = (0, _reactRouterDom.useParams)(),
    id = _useParams.id;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isTabLoading = _useState4[0],
    setIsTabLoading = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    assignmentList = _useState6[0],
    setAssignmentList = _useState6[1];
  var _useState7 = (0, _react.useState)(groups && (groups.find(function (group) {
      return group.groupId === Number(id);
    }) || groups[0])),
    _useState8 = _slicedToArray(_useState7, 2),
    currentGroup = _useState8[0],
    setCurrentGroup = _useState8[1];
  (0, _react.useEffect)(function () {
    getAssignmentList();
  }, [currentGroup]);
  function getAssignmentList() {
    return _getAssignmentList.apply(this, arguments);
  }
  function _getAssignmentList() {
    _getAssignmentList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              setIsLoading(true);
              _cccisdApollo.client.query({
                query: _assignment["default"],
                fetchPolicy: 'network-only',
                variables: {
                  groupId: questprojectIds,
                  assignmentHandle: 'outcomes_data'
                }
              }).then( /*#__PURE__*/function () {
                var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(res) {
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          _context6.next = 2;
                          return setAssignmentList(res.data.flows.assignmentList);
                        case 2:
                          setIsLoading(false);
                        case 3:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6);
                }));
                return function (_x6) {
                  return _ref16.apply(this, arguments);
                };
              }())["catch"](function (err) {
                return console.error(err);
              });
            case 2:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
    return _getAssignmentList.apply(this, arguments);
  }
  var changeGroup = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return setIsLoading(true);
            case 2:
              _context.next = 4;
              return setCurrentGroup(e);
            case 4:
              setIsLoading(false);
            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function changeGroup(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var TimepointPicker = function TimepointPicker(_ref3) {
    var timepoints = _ref3.timepoints,
      currentTimepoint = _ref3.currentTimepoint,
      changeTimepoint = _ref3.changeTimepoint;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "btn-group",
      role: "group",
      style: {
        padding: 0
      }
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-lg btn-primary dropdown-toggle",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }, currentTimepoint.label, '   ', /*#__PURE__*/_react["default"].createElement("span", {
      className: "caret"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "dropdown-menu",
      style: {
        width: 'auto'
      }
    }, timepoints.map(function (timepoint, i) {
      return /*#__PURE__*/_react["default"].createElement("button", {
        key: i,
        type: "button",
        className: (0, _classnames["default"])(_style["default"].dropdownItem, currentTimepoint.hash === timepoint.hash && _style["default"].dropdownItemActive),
        onClick: function onClick() {
          return changeTimepoint(timepoint);
        }
      }, timepoint.label);
    })));
  };
  function SurveyOptions(_ref4) {
    var surveyList = _ref4.surveyList,
      deployment = _ref4.deployment,
      currentTimepoint = _ref4.currentTimepoint;
    function _onSubmit2(_x2, _x3) {
      return _onSubmit.apply(this, arguments);
    }
    function _onSubmit() {
      _onSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(values, closeModal) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _cccisdAxios["default"].put(Boilerplate.route('api.assignmentDeployment.update', {
                  deploymentId: deployment.deploymentId
                }), {
                  settings: _objectSpread(_objectSpread({}, deployment.settings), {}, {
                    outcomesOptions: _objectSpread(_objectSpread({}, deployment.settings.outcomesOptions), {}, _defineProperty({}, currentGroup.groupId, values.surveys))
                  })
                }).then(function (res) {
                  if (res.data.status === 'error') {
                    console.error(res.data.errors);
                    (0, _cccisdNotification["default"])({
                      message: 'There was a problem updating the survey options. Options were not saved.',
                      type: 'danger'
                    });
                  } else {
                    getAssignmentList();
                    closeModal();
                    (0, _cccisdNotification["default"])('Survey options successfully updated.');
                  }
                })["catch"](function (err) {
                  console.error(err);
                  (0, _cccisdNotification["default"])({
                    message: 'Could not update survey options. Please try again.',
                    type: 'danger'
                  });
                });
              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _onSubmit.apply(this, arguments);
    }
    function validate(values) {
      var errors = {};
      if (values.surveys.length === 0) {
        errors.surveys = 'At least one survey must be selected.';
      }
      return errors;
    }
    return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      title: "Customize Surveys for ".concat(currentGroup.label, " at Timepoint ").concat(currentTimepoint.label),
      renderTrigger: function renderTrigger(_ref5) {
        var onClick = _ref5.onClick;
        return /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-lg btn-default",
          onClick: onClick
        }, /*#__PURE__*/_react["default"].createElement(_list["default"], {
          spaceRight: true
        }), "".concat(deployment.settings.outcomesOptions && deployment.settings.outcomesOptions[currentGroup.groupId] ? deployment.settings.outcomesOptions[currentGroup.groupId].length : deployment.settings.options.length, " Survey(s)"));
      },
      render: function render(_ref6) {
        var closeModal = _ref6.closeModal;
        return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
          validate: validate,
          onSubmit: function onSubmit(values) {
            return _onSubmit2(values, closeModal);
          },
          initialValues: {
            surveys: deployment.settings.outcomesOptions && deployment.settings.outcomesOptions[currentGroup.groupId] ? deployment.settings.outcomesOptions[currentGroup.groupId] : deployment.settings.options
          }
        }, function (_ref7) {
          var isSubmitting = _ref7.isSubmitting,
            submitForm = _ref7.submitForm;
          return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "surveys",
            label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
              label: "Surveys",
              tooltip: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, "Select the survey(s) you want to present to respondents for this timepoint."))
            }),
            component: _SurveySelector["default"],
            surveyList: surveyList
          }), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              display: 'flex',
              justifyContent: 'flex-end'
            }
          }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
            className: "btn btn-primary",
            isLoading: isSubmitting,
            isDisabled: isSubmitting,
            onClick: function onClick() {
              return submitForm();
            }
          })));
        });
      }
    });
  }
  var getPreviousTimepointData = function getPreviousTimepointData(currHandle, assnID) {
    if (currHandle && tableQuery && flowDefaultValues && formatDefaultValues) {
      var assignmentNeedingPreviousSessionData = assignmentList.filter(function (assignment) {
        return assignment.settings.navigationSettings.accessPreviousSession && assignment.assignmentId === assnID;
      });
      if (assignmentNeedingPreviousSessionData.length === 1) {
        var timepointsInOrder = assignmentNeedingPreviousSessionData[0].settings.navigationSettings.timepoints;
        var currentIndex = timepointsInOrder.findIndex(function (el) {
          return el.handle === currHandle;
        });
        if (currentIndex !== 0) {
          var prevSessionDeploymentHandle = timepointsInOrder[currentIndex - 1].handle;
          return prevSessionDeploymentHandle;
        }
        return null;
      }
    }
  };
  function RenderContent(_ref8) {
    var assignment = _ref8.assignment;
    var _useState9 = (0, _react.useState)(assignment.settings.navigationSettings.timepoints[0]),
      _useState10 = _slicedToArray(_useState9, 2),
      currentTimepoint = _useState10[0],
      setCurrentTimepoint = _useState10[1];
    var _useState11 = (0, _react.useState)(assignment.deploymentList.find(function (d) {
        return d.deploymentHandle === currentTimepoint.handle;
      })),
      _useState12 = _slicedToArray(_useState11, 2),
      deployment = _useState12[0],
      setDeployment = _useState12[1];
    var _useState13 = (0, _react.useState)(false),
      _useState14 = _slicedToArray(_useState13, 2),
      isTableLoading = _useState14[0],
      setIsTableLoading = _useState14[1];
    var _useState15 = (0, _react.useState)({
        state: {},
        table: {
          state: {
            selectedRows: [],
            data: []
          }
        }
      }),
      _useState16 = _slicedToArray(_useState15, 2),
      rtComponent = _useState16[0],
      setRtComponent = _useState16[1];
    var tableRef = (0, _react.useRef)();
    (0, _react.useEffect)(function () {
      setRtComponent(_objectSpread(_objectSpread({}, rtComponent), {}, {
        table: tableRef.current
      }));
    }, [tableRef.current]);
    (0, _react.useEffect)(function () {
      setDeploymentInfo(deployment);
    }, []);
    var changeTimepoint = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e) {
        var newDeployment;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return setIsTableLoading(true);
              case 2:
                newDeployment = assignment.deploymentList.find(function (d) {
                  return d.deploymentHandle === e.handle;
                });
                _context3.next = 5;
                return setCurrentTimepoint(e);
              case 5:
                _context3.next = 7;
                return setDeployment(newDeployment);
              case 7:
                _context3.next = 9;
                return setDeploymentInfo(newDeployment);
              case 9:
                setIsTableLoading(false);
              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return function changeTimepoint(_x4) {
        return _ref9.apply(this, arguments);
      };
    }();
    var setDeploymentInfo = /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(d) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.t0 = d.type;
                _context4.next = _context4.t0 === 'anon' ? 3 : _context4.t0 === 'known' ? 6 : _context4.t0 === 'group' ? 9 : 17;
                break;
              case 3:
                _context4.next = 5;
                return setRtComponent(_objectSpread(_objectSpread({}, rtComponent), {}, {
                  state: {
                    userPath: 'pawn.',
                    pawnIdPath: '',
                    statusPath: ''
                  }
                }));
              case 5:
                return _context4.abrupt("break", 17);
              case 6:
                _context4.next = 8;
                return setRtComponent(_objectSpread(_objectSpread({}, rtComponent), {}, {
                  state: {
                    userPath: 'pawn.',
                    statusPath: 'pawn.assignmentProgress.',
                    pawnIdPath: ''
                  }
                }));
              case 8:
                return _context4.abrupt("break", 17);
              case 9:
                if (!d.settings.closedRoster) {
                  _context4.next = 14;
                  break;
                }
                _context4.next = 12;
                return setRtComponent(_objectSpread(_objectSpread({}, rtComponent), {}, {
                  state: {
                    userPath: 'pawn.',
                    statusPath: 'pawn.assignmentProgress.',
                    pawnIdPath: ''
                  }
                }));
              case 12:
                _context4.next = 16;
                break;
              case 14:
                _context4.next = 16;
                return setRtComponent(_objectSpread(_objectSpread({}, rtComponent), {}, {
                  state: {
                    pawnIdPath: 'pawn.',
                    statusPath: 'assignmentProgress.',
                    userPath: ''
                  }
                }));
              case 16:
                return _context4.abrupt("break", 17);
              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return function setDeploymentInfo(_x5) {
        return _ref10.apply(this, arguments);
      };
    }();
    var columns = [].concat(_toConsumableArray(tableColumns), [{
      name: 'assignmentProgress.status',
      label: 'Status',
      sort: true,
      filter: true,
      filterSettings: {
        type: 'selectbox',
        placeholder: '-- Choose one --',
        options: [{
          label: 'Not Started',
          value: 'Not Started'
        }, {
          label: 'In Progress',
          value: 'In Progress'
        }, {
          label: 'Complete',
          value: 'Complete'
        }]
      },
      render: function render(_ref11) {
        var value = _ref11.value;
        if (value === 'Complete') {
          return /*#__PURE__*/_react["default"].createElement("span", {
            className: "label label-success"
          }, "Complete");
        }
        if (value === 'In Progress') {
          return /*#__PURE__*/_react["default"].createElement("span", {
            className: "label label-warning"
          }, "In Progress");
        }
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: "label label-default"
        }, "Not Started");
      }
    }, {
      name: "messageCount",
      label: 'Messages Sent',
      render: function render(_ref12) {
        var value = _ref12.value,
          row = _ref12.row;
        return /*#__PURE__*/_react["default"].createElement(_LoggedPawnMessages["default"], {
          deploymentId: deployment.deploymentId,
          pawnIdPath: "pawn.",
          row: row,
          userPath: ""
        });
      }
    },
    // TO SHOW PREVIOUS SESSION'S VALUES

    /* 1. From the Quest Design page, add `accessPreviousSession: true` to the navigation settings 
    JSON for any Outcomes Data Entry players that will need to show the previous session's data. 
    For example:
     "navigationSettings": {
        "respondent": "Participant",
        "roleHandle": "learner",
         "accessPreviousSession": true,
        "timepoints": [...
     2. There is a specific shape `flowProps.defaultValueVariables` needs to have in order
    to show values from the previous session as default values in the current session. In your
    app code, add:
         a) A custom function as a prop from your app's OutcomesDataEntry called `formatDefaultValues`.
        In the 3C site we just use it to give each element of `userRows` an `id` and a `label`.
    
        b) A custom table query that looks specifically for the previous session's data.
        See the `previousTimepointHandle` we use as a graphql variable for the <Table /> in this component.
         c) In your app's flow.json, we need a `rowPath` key with the corresponding value of the path
         to get the data from your custom table query.
     For an example, look at  3C site's <ProgressData /> and it's corresponding tableQuery.graphql.
    Also check out it's flow.json. Here's the final shape of what we send:
     <DeploymentPlayer flowProps={{
        defaultValueVariables: {
             "GroupSessionProgressIssues": {
                "userRows": [
                    {
                       "id": 0,
                       "label": "interrupts"
                   },
                   {
                       "id": 1,
                        "label": "Bullies younger classmates"
                   }
               ]
            }
        },
      }}
    />
     Note that we’ll use the array in `defaultValueVariables` from each app’s flow.json,
    typically living at storage/app/appdefs/flow.json. Here's the 3C site's
    `defaultValueVariables` from flow.json as an example:
        "defaultValueVariables": [
            {
                "handle": "GroupSessionProgressIssues",
                "label": "Progress Negative",
                "rowPath": "prevSession.GroupSessionProgressIssues.GroupSessionProgressIssues"
            },
        ]
    Each element in the flow.json array needs a `handle` and a `rowPath` */

    {
      name: 'actions',
      label: 'Actions',
      render: function render(_ref13) {
        var row = _ref13.row;
        var getPreviousDeploymentValues = function getPreviousDeploymentValues() {
          var prevSessData = flowDefaultValues.map(function (el) {
            return formatDefaultValues(row[el.rowPath], el.handle);
          });

          // `initialValues` needs to be an object
          var format = function format() {
            var obj = {};
            for (var i = 0; i < prevSessData.length; i++) {
              var results = _objectSpread({}, prevSessData[i]);
              (0, _merge2["default"])(obj, results);
            }
            return obj;
          };
          var initialValues = format();
          return initialValues;
        };
        if (assignment.settings.navigationSettings.hideRowActionsWhenComplete && row['assignmentProgress.status'] === 'Complete') {
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            display: 'flex'
          }
        }, assignment.settings.navigationSettings.openDeploymentInNewTab ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Take Survey(s)"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          type: "button",
          className: "btn btn-primary btn-sm",
          style: {
            margin: '0 0 0 0.5rem'
          },
          href: Boilerplate.url("d/".concat(currentTimepoint.hash, "/").concat(row['pawn.respondentHash'])),
          target: "_blank",
          rel: "noopener noreferrer"
        }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null))) : /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
          title: "Surveys for ".concat(row["fields.".concat(modalTitleField)] || row['user.username'] || "System ID #".concat(row['pawn.pawnId'])),
          trigger: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: row['assignmentProgress.status'] === 'Complete' ? "View & Edit Survey(s)" : "Take Survey(s)"
          }, /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-primary btn-sm",
            style: {
              margin: '0 0 0 0.5rem'
            }
          }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null))),
          size: "80%",
          beforeClose: function beforeClose() {
            return tableRef.current.loadData();
          },
          bodyStyle: {
            overflow: 'scroll'
          }
        }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelAssignment.DeploymentPlayer, {
          deploymentHandle: currentTimepoint.handle,
          pawnId: row['pawn.pawnId'],
          pawnHash: row['pawn.pawnHash'],
          respondentHash: row['pawn.respondentHash'],
          flowProps: _objectSpread(_objectSpread({}, currentGroup.flowProps), {}, {
            variables: _objectSpread(_objectSpread({}, currentGroup.flowProps && currentGroup.flowProps.variables), Object.entries(row).reduce(function (a, c) {
              var key = c[0];
              var val = c[1];
              if (key.includes('user.')) {
                return _objectSpread(_objectSpread({}, a), {}, _defineProperty({}, "".concat(key), val));
              }
              if (key.includes('fields.')) {
                return _objectSpread(_objectSpread({}, a), {}, _defineProperty({}, "".concat(key), val));
              }
              return a;
            }, {})),
            defaultValueVariables: tableQuery && flowDefaultValues && formatDefaultValues ? _objectSpread({}, getPreviousDeploymentValues()) : {}
          }),
          disableLayout: true,
          enablePrintMode: true,
          assignmentOptions: deployment.settings.outcomesOptions && deployment.settings.outcomesOptions[currentGroup.groupId] ? deployment.settings.outcomesOptions[currentGroup.groupId] : deployment.settings.options
        })), /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Copy Link"
        }, /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-default btn-sm",
          style: {
            margin: '0 0 0 0.5rem'
          },
          onClick: function onClick() {
            return (0, _UrlInfo.setClipboardText)(Boilerplate.url("d/".concat(currentTimepoint.hash, "/").concat(row['pawn.respondentHash'])));
          }
        }, /*#__PURE__*/_react["default"].createElement(_copy["default"], null))));
      }
    }, {
      name: 'link',
      label: 'Survey Link',
      render: function render(_ref14) {
        var value = _ref14.value,
          row = _ref14.row;
        return /*#__PURE__*/_react["default"].createElement("a", {
          href: "mailto:".concat(Boilerplate.url("d/".concat(currentTimepoint.hash, "/").concat(row['pawn.respondentHash'])))
        }, Boilerplate.url("d/".concat(currentTimepoint.hash, "/").concat(row['pawn.respondentHash'])));
      },
      hideInTable: true
    }]).filter(function (col) {
      // if isProvider is true, don't show the 'Messages Sent' column
      if (assignment.settings.navigationSettings.isProvider) {
        return col.name !== 'messageCount';
      }
      return true;
    });
    var defaultQueryVariables = {
      groupId: currentGroup.groupId,
      deploymentId: deployment.deploymentId,
      deploymentHandle: currentTimepoint.handle,
      roleHandle: assignment.settings.navigationSettings.roleHandle,
      tableFields: tableFields
    };
    var customQueryVariables = _objectSpread(_objectSpread({}, defaultQueryVariables), {}, {
      previousTimepointHandle: getPreviousTimepointData(currentTimepoint.handle, assignment.assignmentId)
    });
    return !isTabLoading && /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        padding: '2rem'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: 0
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "btn-group",
      role: "group",
      style: {
        marginBottom: '2rem'
      }
    }, /*#__PURE__*/_react["default"].createElement(TimepointPicker, {
      timepoints: assignment.settings.navigationSettings.timepoints,
      currentTimepoint: currentTimepoint,
      changeTimepoint: changeTimepoint
    }), /*#__PURE__*/_react["default"].createElement(SurveyOptions, {
      surveyList: assignment.surveyList,
      currentTimepoint: currentTimepoint,
      deployment: deployment
    })), !assignment.settings.navigationSettings.isProvider && /*#__PURE__*/_react["default"].createElement("div", {
      role: "group",
      className: "btn-group"
    }, rtComponent && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      trigger: /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-primary btn-lg"
      }, /*#__PURE__*/_react["default"].createElement(_envelop["default"], {
        spaceRight: true
      }), " Send Message"),
      title: "Send Message"
    }, /*#__PURE__*/_react["default"].createElement(_SendMessageNow["default"], {
      messageQuery: messageQuery,
      rtComponent: rtComponent,
      match: {
        params: {
          deploymentId: assignment.deploymentList.find(function (d) {
            return d.deploymentHandle === currentTimepoint.handle;
          }).deploymentId
        }
      },
      deployment: assignment.deploymentList.find(function (d) {
        return d.deploymentHandle === currentTimepoint.handle;
      }),
      groupId: currentGroup.groupId,
      roleHandle: assignment.settings.navigationSettings.roleHandle
    })))), !isTableLoading && /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
      rowKey: "pawn.pawnId",
      query: tableQuery || _table["default"],
      graphqlVariables: tableQuery && flowDefaultValues && formatDefaultValues ? customQueryVariables : defaultQueryVariables,
      columns: columns,
      ref: tableRef,
      rowActions: [{
        name: 'noop',
        title: '',
        action: function action() {}
      }]
    }));
  }
  if (!isLoading && groups.length === 0) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '10rem'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h2", null, "No groups were found.", ' ', /*#__PURE__*/_react["default"].createElement("span", {
      role: "img",
      "aria-label": "Thinking Emoji"
    }, "\uD83E\uDD14")), /*#__PURE__*/_react["default"].createElement("p", null, "Please verify that groups have been created for this site.")));
  }
  if (!isLoading && id && !groups.find(function (group) {
    return group.groupId === Number(id);
  })) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '10rem'
      }
    }, /*#__PURE__*/_react["default"].createElement("h2", null, "Invalid Group ID provided in the URL.", ' ', /*#__PURE__*/_react["default"].createElement("span", {
      role: "img",
      "aria-label": "Gasp Emoji"
    }, "\uD83D\uDE31")));
  }
  if (!isLoading && assignmentList && assignmentList.length === 0) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '10rem'
      }
    }, /*#__PURE__*/_react["default"].createElement("h2", null, "There doesn't appear to be an Outcomes Data quest configured. ", /*#__PURE__*/_react["default"].createElement("span", {
      role: "img",
      "aria-label": "Gasp Emoji"
    }, "\uD83D\uDE22")), /*#__PURE__*/_react["default"].createElement("p", null, "If this problem persists, please contact the 3C Institute support team."));
  }
  return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
    loading: isLoading
  }, currentGroup && assignmentList && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      margin: '1em'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h1", null, /*#__PURE__*/_react["default"].createElement("strong", null, title)), /*#__PURE__*/_react["default"].createElement("p", null, description)), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "btn-group",
    role: "group"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-lg btn-primary dropdown-toggle",
    "data-toggle": "dropdown",
    "aria-haspopup": "true",
    "aria-expanded": "false"
  }, currentGroup.label, " ", /*#__PURE__*/_react["default"].createElement("span", {
    className: "caret"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "dropdown-menu dropdown-menu-right",
    style: {
      width: 'auto'
    }
  }, groups.map(function (group, i) {
    return /*#__PURE__*/_react["default"].createElement("button", {
      key: i,
      type: "button",
      className: (0, _classnames["default"])(_style["default"].dropdownItem, currentGroup.groupId === group.groupId && _style["default"].dropdownItemActive),
      onClick: function onClick() {
        return changeGroup(group);
      }
    }, group.label);
  }))))), /*#__PURE__*/_react["default"].createElement("br", null), !isLoading && /*#__PURE__*/_react["default"].createElement("div", {
    className: _cccisdStyleBible["default"].impactTabs1
  }, /*#__PURE__*/_react["default"].createElement(_cccisdTabs["default"], {
    tabList: assignmentList.map(function (assignment) {
      return {
        name: assignment.settings.navigationSettings.respondent.split('').map(function (c) {
          return c === ' ' ? '%20' : c;
        }).join(''),
        title: assignment.settings.navigationSettings.respondent,
        content: /*#__PURE__*/_react["default"].createElement(RenderContent, {
          assignment: assignment
        })
      };
    }),
    onTabSelect: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return setIsTabLoading(true);
            case 2:
              setIsTabLoading(false);
            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })),
    saveInHash: true
  }))));
}
var _default = OutcomesData;
exports["default"] = _default;